import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
import DiscoverCard from './_discover_card';
import { discover } from './__data';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(0),
  },
  paperTitle: {
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    paddingTop: '5rem',
    paddingBottom: '8rem'
  }
}));

const Discover = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="section"
        item
        xs={12}
      >
        <Paper
          className={classes.paperTitle}
          component="header"
        >
          <Typography
            align="center"
            component="h2"
            variant="h1"
          >
            Découvrez un univers
          </Typography>
          <Typography
            align="center"
            component="p"
            variant="body2"
          >
            Même si l'aventure en solitaire est très plaisante sur SeedOut Fenua, nous proposons aux joueurs de progresser, d'explorer le monde des autres joueurs ou encore d'inviter des amis pour faire équipe dans un monde commun.
          </Typography>
        </Paper>
        <Grid
          container
          justify="center"
          xs={12}
        >
          {discover.map((element, index) => {
            return (
              <Grid
                item
                key={`discover-${index}`}
                md={4}
                sm={4}
                xs={6}
              >
                <Paper
                  className={classes.paper}
                  elevation={0}
                  square
                >
                  <DiscoverCard element={element}/>
                </Paper>
              </Grid>
            )
          })}
        </Grid>
      </Grid>

    </>
  );
}

export default Discover;
